import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=bd2adbbc&scoped=true&"
import script from "./NewPassword.vue?vue&type=script&lang=js&"
export * from "./NewPassword.vue?vue&type=script&lang=js&"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=bd2adbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2adbbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VSnackbar,VTextField})
